import { render } from "./NewCase.vue?vue&type=template&id=7b736663&scoped=true"
import script from "./NewCase.vue?vue&type=script&lang=js"
export * from "./NewCase.vue?vue&type=script&lang=js"

import "./NewCase.vue?vue&type=style&index=0&id=7b736663&scoped=true&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b736663"]])

export default __exports__